import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Rating from 'components/Rating';
import format from 'date-fns/format';
import useDateLocale from 'components/useDateLocale';
import { getIcon } from './utils';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginBottom: 24,
  },
  avatar: {
    width: 48,
    height: 48,
    marginRight: 23,
  },
  starAndDateWrapper: {
    display: 'flex',
    marginTop: 6,
    alignItems: 'center',
  },
  starIcon: {
    height: 12,
  },
  date: {
    marginLeft: 11,
    color: theme.palette.text.disabled,
  },
  typeIcon: {
    marginLeft: 10,
  },
  reviewWrapper: {
    marginTop: 10,
  },
}));

const avatarColorSet = ['#66C2B6', '#64BDDF', '#B270C5'];

function UserReview({ data }) {
  const classes = useStyles();
  const colorIndex = useRef(Math.floor(Math.random() * 3));
  const dateFormatFilter = useDateLocale();

  const { body, date, person, rating, person_img, type } = data;

  if (_isEmpty(person)) return null;

  const formattedDate = !Number.isNaN(Number(date));
  const hasReview = !_isEmpty(_get(data, 'body'));
  const [firstName, lastName = ''] = person.split(' ');
  const personName = `${firstName} ${lastName &&
    lastName.charAt(0).toUpperCase()}`;

  return (
    <Grid item xs={12}>
      <Grid container className={classes.wrapper}>
        <Grid item>
          <Avatar
            src={person_img}
            className={classes.avatar}
            style={{
              backgroundColor: avatarColorSet[colorIndex.current],
            }}
            alt={person}
          >
            {!person_img && person.charAt(0)}
          </Avatar>
        </Grid>
        <Grid item xs>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="caption" color="textPrimary">
                {personName}
              </Typography>
              <img
                src={getIcon(type)}
                alt={type}
                className={classes.typeIcon}
              />
            </Grid>
            <Grid item xs={12} className={classes.starAndDateWrapper}>
              <Rating name="user-rating" value={rating} />
              <Typography
                variant="overline"
                color="textPrimary"
                className={classes.date}
              >
                {formattedDate
                  ? format(date, 'MMM dd, yyyy', {
                      locale: dateFormatFilter,
                    })
                  : date}
              </Typography>
            </Grid>
            {hasReview && (
              <Grid item xs={12} className={classes.reviewWrapper}>
                <Typography variant="overline" color="textPrimary">
                  {body}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

UserReview.propTypes = {
  data: PropTypes.object,
};

export default UserReview;
